import type { MarketingProject } from '../types/project';
import { mapMarketingProject } from '../utils/project';
import { handleServiceError } from '../utils/errorHandler';
import { requestEdgeFunction } from './edgeFunctionClient';

class MarketingProjectServiceClass {
  async listForFilters(): Promise<MarketingProject[]> {
    const response = await requestEdgeFunction<{ success?: boolean; data?: unknown[] }>('students', {
      method: 'POST',
      body: {
        action: 'list-marketing-projects',
        payload: {},
      },
    }).catch((error) => {
      handleServiceError(error, 'carregar projetos');
      throw error;
    });

    return (response.data ?? [])
      .map((row) => mapMarketingProject(row))
      .filter((project): project is MarketingProject => project != null);
  }
}

export const MarketingProjectService = new MarketingProjectServiceClass();
